import React from 'react'
import './Home.scss'
import { useNavigate, Link } from 'react-router-dom';
import { images } from '../../constants'

const Home = ({DarkMode, SetDarkMode, Page, SetPage}) => {
  const navigate = useNavigate();

  const handleWork = () => {
    navigate('/work');
    SetPage('/work')
  };

  const workdata = [
    {id:'01', title:'MakeNTU KV', category:'GRAPHIC DESIGN', img:images.makentu},
    {id:'02', title:'Paintings', category:'PAINTING', img:images.matterhorn},
    {id:'03', title:'Culture ToGather', category:'UI/UX FRONTEND', img:images.culture}
  ]

  return (
    <div id='home'>
      <div className='home-page' style={{backgroundColor: DarkMode?'var(--primary-color)':'var(--primary-color)'}}>
        <div className='home-page-left animate__animated animate__fadeInUp' style={{color: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}>
          <h1>Hello,</h1>
          <h2>I'm</h2>
          <h3>Henning.</h3>
          <p>Hello, i'm Henning Yang. I am a passionate UI/UX and frontend designer and artist. </p>
          <div className='home-page-see-my-work' onClick={() => handleWork()}>
            <div className='see-my-work-circle' style={{backgroundColor:DarkMode?'rgb(224, 224, 224)':'rgb(224, 224, 224)'}}/>
            <p>SEE MY WORKS</p>
            <i class="fas fa-sharp fa-solid fa-chevron-right"></i>
          </div>
        </div>
        <div className='home-page-middle animate__animated animate__fadeInDown'>
          <img className='astronaut' src={images.astronaut} alt="home-page-pic" />
        </div>
        <div className='home-page-right' style={{color: DarkMode?'var(--darkgray-color)':'var(--darkgray-color)'}}>
          <p>... SCROLL DOWN ...</p>
          <i class="fas fa-sharp fa-solid fa-chevron-down"></i>
        </div>
      </div>
      <div className='home-page-second-part'>
        <div className='second-part-intro'>
          <h1 data-aos="fade-right">Make amazing ideas into reality.</h1>
          <p>These are a selection of my works.</p>
        </div>
        <ul className='second-part-work'>
          <hr/>
          { workdata.map((item)=> (
            <>
              <li key={item.id} style={{color:'var(--darkgray-color)'}} >
                <div className='second-part-work-id'>{item.id}</div>
                <div className='second-part-work-name'>
                  <h2>{item.title}</h2>
                  <p>{item.category}</p>
                </div>
                <div className='second-part-work-see'>
                  <img src={item.img} alt={item.id} />
                  <Link to={`/work/${item.id}`} className='see-more'>
                    <div className='see-more-circle'/>
                    <p>SEE PROJECT</p>
                    <i class="fas fa-sharp fa-solid fa-chevron-right"></i>
                  </Link>
                </div>
              </li>
              <hr/>
            </>
          )) }
        </ul>
        <div className='see-all-projects'>
            <p>WANT TO SEE MORE?</p>
            <div onClick={() => handleWork()} data-aos="fade-right">
              <h2>View all projects</h2>
              <i class="fas fa-sharp fa-solid fa-chevron-right"></i>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Home